import {
  useCategorySuggestionsMap,
  useSuggestionsFromProvider,
  useSuggestionsUuidMap,
} from '~/providers/RootDataProvider';

export const useSuggestions = () => {
  return useSuggestionsFromProvider();
};

export const useCategoryReportIds = () => {
  return useCategorySuggestionsMap();
};

export const useSuggestionByUuid = (uuid: string) => {
  const suggestionsMap = useSuggestionsUuidMap();
  return suggestionsMap.get(uuid);
};
